
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FundingCharge } from 'ah-api-gateways';
import { useSettingsStore } from '@/app/store/settingsModule';

interface CountryCodePair {
  countryName: string;
  countryCode: string;
}

@Component
export default class AcoTiersList extends Vue {
  @Prop({ required: true }) fees!: FundingCharge[];

  created() {
    this.settingsStore.loadCountries();
  }

  get settingsStore() {
    return useSettingsStore();
  }

  get countries() {
    return this.settingsStore.allCountries;
  }

  get sortedList() {
    if (this.fees.length === 0) {
      return null;
    }
    const sectionTierList = [] as Array<CountryCodePair>;
    this.fees.forEach((fee) =>
      sectionTierList.push({ countryName: this.getCountryName(fee.countryCode), countryCode: fee.countryCode })
    );
    return sectionTierList.sort((a, b) => (a.countryName > b.countryName ? 1 : -1));
  }

  private isFirstLetter(index: number) {
    if (!this.sortedList) return false;
    const diff = index !== 0 && this.sortedList[index].countryName[0] !== this.sortedList[index - 1].countryName[0];
    return index === 0 || diff;
  }

  private lastOfSection(index: number) {
    if (!this.sortedList) return false;
    if (index === this.sortedList.length - 1) return true;
    const diff = this.sortedList[index].countryName[0] !== this.sortedList[index + 1].countryName[0];
    return this.sortedList.length > index + 1 && diff;
  }

  private getCountryName(cc: String) {
    const countryName = this.countries.find((country) => country.cc === cc);
    return countryName ? countryName.name : '';
  }
}
